/**
 * Shared Nuxt UI `:ui` map for circular topnav icon buttons (back, account, close).
 * Dark (navy) vs light (cream) chrome follows `bgColor`; defaults to dark.
 */
export default function useTopnavButtonUi(bgColor?: Ref<'dark' | 'light'>) {
    const effectiveBgColor = computed(() => bgColor?.value ?? 'dark')

    /**
     * Circular 44px icon buttons — DS `.crane-icon-btn--topnav` (+ `--light` on cream).
     * Kept as a Nuxt UI `:ui` map so back + account share one recipe.
     */
    return computed(() => {
        const base = [
            'group cursor-pointer size-11 rounded-full p-0 inline-flex items-center justify-center',
            'border transition-[color,background-color,border-color,transform] duration-200',
            'ease-[var(--btn-ease)] active:scale-[0.95]',
        ]
        // Lucide stroke via `--icon-stroke-width` (`icon-stroke-*`); Tailwind `stroke-*` does not apply here.
        const leadingIcon =
            'size-[26px] text-inherit icon-stroke-1.5 group-active:opacity-50 transition-opacity duration-200'

        if (effectiveBgColor.value === 'dark') {
            return {
                base: [
                    ...base,
                    'text-(--white-85) border-(--white-18)',
                    'hover:text-(--gold) hover:border-(--gold) hover:bg-transparent',
                    'active:bg-transparent',
                ].join(' '),
                leadingIcon,
            }
        }

        return {
            base: [
                ...base,
                'text-(--primary-700) border-(--neutral-300)',
                'hover:text-(--gold) hover:border-(--gold) hover:bg-transparent',
                'active:bg-transparent',
            ].join(' '),
            leadingIcon,
        }
    })
}
